import { Box, Container } from "@material-ui/core";
import { AutocompleteAddress } from "components/AutocompleteAddress";
import React, { useEffect, useState } from "react";
import { mapRegionNameToCode } from "util/address/fetchAddressComponents";

const AutoCompleteAddressTest = () => {
  const [selectedLocation, setSelectedLocation] = useState();

  const [region, setRegion] = useState();

  useEffect(() => {
    async function getRegion() {
      if(selectedLocation) {
        setRegion(await mapRegionNameToCode(selectedLocation.region))
      }
    }
    getRegion()
  }, [selectedLocation]);

  return (
    <Container fixed>
      <Box padding={10}>
        <AutocompleteAddress
          onSelectAddress={(address) => setSelectedLocation(address)}
        />
      </Box>
      <pre>{JSON.stringify(selectedLocation, null, 2)}</pre>
      <pre>{JSON.stringify(region, null, 2)}</pre>
    </Container>
  );
};

export { AutoCompleteAddressTest };
